export default __webpack_public_path__ + "static/media/q_right_bg.631c0738.png";